import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import type { UserProfile } from "@/services/api_interface";
import createSelectors from "./create-selector";

interface ProfileStoreState {
  userProfile: UserProfile | undefined;
  isFetched: boolean;
  setUserProfile: (_profile?: UserProfile) => void;
  setIsFetched: (_isFetched: boolean) => void;
  clearUserProfile: () => void;
}

const useProfileStoreBase = create<ProfileStoreState>()(
  immer((set) => ({
    userProfile: undefined,
    isFetched: false,
    setUserProfile: (profile?: UserProfile) => set((state) => { state.userProfile = profile; state.isFetched = true }),
    setIsFetched: (isFetched: boolean) => set((state) => { state.isFetched = isFetched }),
    clearUserProfile: () => set((state) => { state.userProfile = undefined; state.isFetched = false }),
  }))
)

const useProfileStore = createSelectors(useProfileStoreBase);

export default useProfileStore;
